module.exports = __webpack_public_path__ + "img/stella_roux-banner-eng.b657356b.png";